import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Introduction() {
  const navigate = useNavigate();

  // useEffect(()=>{

  // navigate('/introduction');

  // },[])

  return (
    <div class="idocs-content">
      <div class="row">
        <div class="col-md-12">
          <div
            style={{
              color: "#fff !important",
              backgroundColor: "#263f91",
              height: "350px",
            }}
          >
            <h1 class="banner-text">
              Welcome
              <br />
              to Safexpay
              <br />
              Documentation
            </h1>
            <p
              style={{
                color: "#fff",
                float: "left",
                paddingLeft: "140px",
                marginTop: "10px",
              }}
            >
              Welcome to the Safexpay developer documentation. <br />
              You will find help about Safexpay products and APIs <br />
              that will help you start using our products quickly.
            </p>
            <img
              src={process.env.PUBLIC_URL + "/images/Arrow-Green.png"}
              alt="logo"
              style={{
                width: "21%",
                float: "right",
                top: "5%",
                right: "20%",
                position: "absolute",
              }}
            />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content">
              <h1>Introduction</h1>
              <hr />
              <p class="mt-30">
                This document describes the different methods of integration
                between Merchant and <b>Safexpay.</b>
              </p>
              <p className="Introduction-txt">
                <b>Safexpay</b> services provide trustworthy and feasible
                solutions for registered merchants. Register as a merchant with
                us to know more about the features of <b> Safexpay Software Solution Private Limited. </b>
              </p>

              <p>
                <b>Safexpay</b> Payment integration kit allows merchants to
                instantly collect payments from their users using various
                payment modes like Credit cards, Debit cards, Cash cards, BNPL, Wallets.
              </p>
            </section>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}

export default Introduction;
